import { useState } from 'react';
import { CanonicalSectionTabs } from '@urbanik/ui';
import { MemberImportDiagnosticView } from './MemberImportDiagnosticView';
import { MemberImportMappingView } from './MemberImportMappingView';
import { MemberImportPreviewView } from './MemberImportPreviewView';
import { MemberImportSimulationView } from './MemberImportSimulationView';
import { useOrganization } from './OrganizationContext';

type Section = 'diagnostic' | 'mapping' | 'preview' | 'simulation';
const tabs = [
  { id: 'diagnostic', label: 'Diagnóstico' },
  { id: 'mapping', label: 'Mapeo' },
  { id: 'preview', label: 'Vista previa' },
  { id: 'simulation', label: 'Simulación' },
] as const;

export function MemberImportWorkspaceView({ canExecute = false }: { canExecute?: boolean }) {
  const [section, setSection] = useState<Section>('diagnostic');
  const organization = useOrganization();
  const visibleTabs =
    organization?.active.code === 'BASELINE_COMIVALLE'
      ? tabs
      : ([{ id: 'diagnostic', label: 'Carga masiva' }] as const);
  return (
    <>
      <CanonicalSectionTabs
        tabs={visibleTabs}
        activeId={section}
        onChange={(id) => setSection(id as Section)}
        label="Etapas de migración de socios"
      />
      {section === 'diagnostic' ? <MemberImportDiagnosticView /> : null}
      {section === 'mapping' ? <MemberImportMappingView /> : null}
      {section === 'preview' ? <MemberImportPreviewView /> : null}
      {section === 'simulation' ? <MemberImportSimulationView canExecute={canExecute} /> : null}
    </>
  );
}
